module.exports = __webpack_public_path__ + "assets/615c4a55e92982fbc1dd2dc29ce2f4cd.mp3";